import { render, staticRenderFns } from "./VOpenDays.vue?vue&type=template&id=99dfc7dc&"
import script from "./VOpenDays.vue?vue&type=script&lang=js&"
export * from "./VOpenDays.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports